<template>
<div>
  <loading v-if="isloading"></loading>
  <div  v-else class="container">
    <top-bar v-if="curUser" :user="curUser" @updateProfile="updateProfile" @showTip="showTip"></top-bar>
    <!-- <list-item v-if="contents.length" from="profile" v-for="(item, index) in contents" :index="index" :data="item" :is_it_self="user.is_it_self">
    </list-item> -->
    <community-list v-if="contents.length>0 && contents[0]!==''" :id="typeId" 
      from="profile"  :is_it_self="user.is_it_self"
      :list="contents" 
      ref="communityList"
      ></community-list>
    <div v-if="!contents.length" class="no-data">
      <router-link to="/publish/99">
        <i class="iconfont icon-meiyouneirong"></i>
        <p>点击立即报料！</p>
      </router-link>
    </div>
    <modal v-show="tip" ref="tip" :download="download" :content="tip"></modal>
  </div>
      
</div>
</template>
<script>
  import Modal from 'components/tips/Modal.vue';
  import Loading from 'components/tips/Loading.vue';
  import CommunityList from 'components/list/CommunityList.vue';
  import ListItem from 'components/list/ListItem.vue';
  import TopBar from './topbar/TopBar.vue';

  import { getProfile, getDetail, getComments } from 'assets/js/community.js';

  export default {
    name: 'Profile',
    components:{
      ListItem,
      TopBar,
      CommunityList,
      Modal,
      Loading
    },
    data(){
      return {
        contentId: '',
        curUser: '',
        contents: [],
        typeId: 99,

        user: '',
        tip: '',
        download: true,
        isloading: true
      }
    },
    computed:{
      tokens(){
        return this.$store.state.tokens;
      }
    },
    created(){
      console.log('profile params: ',this.$route.params, this.$route.query);
      this.id = this.$route.params.id;
      this.contentId = this.$route.query.contentId;
      this.user = this.$route.query;
      // this.$store.dispatch('cbgcAuth', {
      //   cacheName: 'cbgcAuth',
      //   refresh: 1
      // }).then(res=>{
      //   this.loadData();
      // });
      this.loadData();
      // this.init(this.$route.query.from);
    },
    methods: {
      async init(from){
        console.log('from:', from, from!=='detail');
        if(from !== 'detail'){
          getComments(this.contentId, this.tokens).then(res=>{
            this.user = res.data.data[from].user;
            this.loadData();
          });
        }else{
          getDetail(this.contentId, this.tokens).then(res=>{
            this.user = res.data[0].user;
            this.loadData();
          });
        }
        
      },
      async loadData(){
        let tokens = this.tokens || await this.$store.dispatch('cbgcAuth');
        if(tokens.status){
          this.$emit('showTip', tokens.message);
          return;
        }
        tokens = typeof tokens == 'string' ? tokens : tokens.access_token;
        getProfile(this.id, this.tokens).then(res=>{
          let user = this.user;
          this.curUser = Object.assign({}, this.user, {
            id: this.id,
            like_count: res.data.like_count,
            be_follow_count: res.data.be_follow_count,
            follow_count: res.data.follow_count,
            followed: res.data.followed,
            is_it_self: res.data.is_it_self
          });
          this.contents = res.data.contents;
          this.isloading = false;
        });
      },
      updateProfile(){
        this.loadData();
      },
      showTip(tip){
        this.tip = tip;
        this.$refs.tip.taggle(true);
      }
    }
  }
</script>